<template>
	<div v-if="isFloating" class="position-relative" style="max-width: 100%;">
		<slot name="append"> </slot>
		<div class="small text-gray position-absolute ps-2 ms-1" style="top: 30px; z-index: 0;" v-if="getType == 'color' && !Pmodel">(未設定)</div>
		<input
			style="z-index: 1;"
			class="form-control position-relative"
			:id="BId"
			:type="getType"
			:class="[{ 'text-end': props.type == `number` }, sClass, inputClass]"
			:inputmode="inputmode"
			v-model="Pmodel"
			@blur="checkValue"
			:disabled="disabled"
			@focus="focusFunc($event)"
			@keydown="InKeyDown($event)"
			:placeholder="placeholder"
			:autocomplete="props.type != 'searchInput' ? `on` : `chrome-off`"
			:true-value="trueValue"
			:false-value="falseValue"
			v-if="isEdit"
		/>
		<div class="form-control" v-else :class="[{ 'text-end': props.type == `number` }, sClass, inputClass]">
			<div v-if="getType == 'color'" style="width: 100%; height: 1.3rem;" :style="{ backgroundColor: Pmodel }"></div>
			<div v-else class="overflow-auto">
				<div class="text-nowrap">{{ getType == "password" ? "********" : Pmodel }}</div>
			</div>
		</div>
		<slot name="end-icon">
			<div class="position-absolute text-gray" style="top: 25px; right: 0;" v-if="type == 'searchInput'">
				<font-awesome-icon :icon="['fas', 'search']" />
			</div>
		</slot>
		<div v-if="showOption" class="position-absolute p-1 border border-dark-subtle border-2 rounded bg-white box-select overflow-y-auto" style="z-index: 900;" :style="{ maxHeight: windowSize[0].value - 200 + `px` }">
			<slot name="optionBox">
				<ul class="list-unstyled mb-0 bg-white">
					<li v-for="item in option" class="cur-point">
						<slot name="optionItem" :item="item" :Ckoption="Ckoption">
							<a aria-current="page" href="#" @click.prevent="Ckoption(item)" class="px-2">{{ item.name }}</a>
						</slot>
					</li>
				</ul>
			</slot>
		</div>
		<slot name="label"></slot>
	</div>
	<div v-else-if="isEdit" class="position-relative">
		<slot name="append"></slot>
		<div class="form-control m-input-box position-relative" :class="[sClass, inputClass]">
			<textarea :id="BId" :class="[sClass, inputClass]" v-if="type == `textarea`" :rows="sRows" :cols="sCols" v-model="Pmodel" @blur="checkValue" :disabled="disabled"></textarea>
			<input
				:id="BId"
				:type="getType"
				:class="[{ 'text-end': props.type == `number` }]"
				:inputmode="inputmode"
				v-model="Pmodel"
				@blur="checkValue"
				:disabled="disabled"
				@focus="focusFunc($event)"
				@keydown="InKeyDown($event)"
				:placeholder="placeholder"
				@keyup.enter.stop="Penter"
				:autocomplete="props.type != 'searchInput' ? `on` : `chrome-off`"
				:true-value="trueValue"
				:false-value="falseValue"
				v-else
			/>
			<!-- <div class="position-absolute" style="top: 25%; right: 5%;" v-if="type == 'searchInput'">
				<font-awesome-icon :icon="['fas', 'caret-down']" />
			</div> -->
			<slot name="end-icon">
				<!-- <div class="position-absolute text-gray" style="top: 6px; right: 10px" v-if="type == 'searchInput'">
					<font-awesome-icon :icon="['fas', 'caret-down']" />
				</div> -->
			</slot>

			<div v-if="showOption" class="position-absolute p-1 border border-dark-subtle border-2 rounded bg-white box-select" style="z-index: 900;">
				<slot name="optionBox">
					<ul class="list-unstyled mb-0 bg-white">
						<li v-for="item in option" class="cur-point">
							<slot name="optionItem" :item="item" :Ckoption="Ckoption">
								<a aria-current="page" href="#" @click.prevent="Ckoption(item)" class="px-2">{{ item.name }}</a>
							</slot>
						</li>
					</ul>
				</slot>
			</div>
		</div>
		<slot name="prepend"></slot>
		<slot name="label"></slot>
	</div>

	<span v-else class="position-relative d-flex align-items-center" :class="[{ 'justify-content-end': props.type == `number` }]">
		<slot name="append"></slot>
		<div class="py-1 px-1">
			<span v-if="getType == 'password'">********</span>
			<span v-else>
				{{ Pmodel }}
			</span>
		</div>
		<slot name="prepend"></slot>
		<slot name="label"></slot>
	</span>
</template>
<script setup lang="ts">
	import type { HTMLAttributes } from "vue";
	import { useWindowSize } from "vue-window-size";
	const props = defineProps({
		model: {
			type: [String, Number],
		},
		inputmode: {
			type: String,
			default: "",
		},
		placeholder: {
			type: String,
		},
		type: {
			type: String,
			default: "text",
		},
		trueValue: {
			type: [String, Number, Boolean],
			default: true,
		},
		falseValue: {
			type: [String, Number, Boolean],
			default: false,
		},
		min: {
			type: [String, Number, null],
			default: null,
		},
		max: { type: [String, Number, null], default: null },
		disabled: {
			type: Boolean,
			default: false,
		},
		isEdit: {
			type: Boolean,
			default: true,
		},
		sRows: [Number, String],
		sCols: [Number, String],
		sClass: [String, Array],
		inputClass: {
			type: [String, Array],
			default: "border border-gray p-1",
		},
		option: {
			type: Array,
			default(): Array<any> {
				return <Array<any>>[];
			},
		},
		showOption: {
			type: Boolean,
			default: false,
		},
		sourceData: {
			type: Array,
			default() {
				return [];
			},
		},
		isFloating: {
			type: Boolean,
			default: false,
		},
	});
	const emit = defineEmits(["update:model", "update:showOption", "Change", "blur", "focusFunc", "optionFunc", "input", "keydown", "enter"]);
	const BId = ref("BI___" + (Math.random() * 10000).toString().replace(".", "__"));
	onMounted(() => {
		document.querySelector("#" + BId.value)?.addEventListener("keydown", optionKeyDow);
	});
	onUnmounted(() => {
		emit("update:showOption", false);
		document.removeEventListener("click", OptionCheck);
		document.querySelector("#" + BId.value)?.removeEventListener("keydown", optionKeyDow);
	});
	const { width, height } = useWindowSize();
	const windowSize = ref([width, height]);
	const Pmodel = computed({
		get() {
			return props.model;
		},
		set(data: any) {
			let check = true;
			let changeData: any = data;
			if (props.type == "number") {
				if (parseInt(props.min) > 0) {
					check = check && parseInt(data || 0) >= parseInt(props.min);
				}
				if (parseInt(props.max) > 0) {
					check = check && parseInt(data || 0) <= parseInt(props.max);
				}
			} else {
				if (parseInt(props.min) > 0) {
					check = check && (data || "").length >= parseInt(props.min);
				}
				if (parseInt(props.max) > 0) {
					check = check && (data || "").length <= parseInt(props.max);
				}
			}
			if (!check) {
				changeData = props.model;
			}
			emit("update:model", changeData);
			emit("input", changeData, props.sourceData);
			emit("Change", changeData, props.sourceData);
		},
	});
	const getType = computed(() => {
		if (["numberL", "number", "tel", "email", "url", "searchInput"].indexOf(props.type) > -1) {
			return "text";
		}
		return props.type;
	});
	const InKeyDown = ($event: any) => {
		let check = true;
		let changeData: any = $event.target.value;
		if (props.type == "number") {
			if (parseInt(props.min) > 0) {
				check = check && parseInt(changeData || 0) > parseInt(props.min);
			}
			if (parseInt(props.max) > 0) {
				check = check && parseInt(changeData || 0) < parseInt(props.max);
			}
		} else {
			if (parseInt(props.min) > 0) {
				check = check && (changeData || "").length > parseInt(props.min);
			}
			if (parseInt(props.max) > 0) {
				check = check && (changeData || "").length < parseInt(props.max);
			}
		}
		if (!check && [8, 37, 39].indexOf($event.keyCode) == -1) {
			// changeData = props.model;
			$event.preventDefault();
		}

		if (!props.showOption && props.type == "searchInput" && $event.keyCode == 40) {
			emit("update:showOption", true);
			emit("input", Pmodel.value, props.sourceData);
		}
		emit("keydown", $event);
	};
	const checkValue = () => {
		if (props.max && Pmodel.value > props.max) {
			Pmodel.value = props.max;
		}
		if (props.min && Pmodel.value < props.min) {
			Pmodel.value = props.min;
		}
		emit("blur");
		setTimeout(() => {
			emit("update:showOption", false);
		}, 500);
	};
	const matchInputMode: { [keys: string]: string } = {
		number: "numeric",
		numberL: "numeric",
		tel: "tel",
		email: "email",
		url: "url",
	};
	const inputmode = computed(() => {
		return <HTMLAttributes["inputmode"]>matchInputMode[props.type] || "";
	});
	const focusFunc = (event: any) => {
		event.target.select();
		emit("focusFunc", event);
	};
	const Ckoption = (item: any) => {
		checkValue();

		emit("optionFunc", item, props.sourceData);
		emit("update:showOption", false);
	};
	const OptionCheck = ($event: any) => {
		if (props.showOption && !($event.target.offsetParent.classList.value.search("box-select") > -1)) {
			emit("update:showOption", false);
		}
	};
	const optionKeyDow = ($event: any) => {};
	const Penter = () => {
		console.log("A");
		emit("enter");
	};
	watch(
		() => {
			return props.showOption;
		},
		(nval) => {
			if (nval && ["searchInput"].indexOf(props.type) > -1) {
				document.addEventListener("click", OptionCheck);
			} else {
				document.removeEventListener("click", OptionCheck);
				document.querySelector("#" + BId.value)?.removeEventListener("keydown", optionKeyDow);
			}
		},
	);
</script>
